import React from "react";
import MultiLanguages from "@admin/components/MultiLanguage";
import { LanguageKeyObject } from "@admin/domain/languages/helpers";
import Input from "@admin/components/Input";
import TextArea from "@admin/components/TextArea";

type Props = {
    broadcastIndex: number;
    title: LanguageKeyObject;
    description: LanguageKeyObject;
};

export default function Texts({ broadcastIndex, title, description }: Props) {
    return (
        <MultiLanguages
            languageElement={(language) => (
                <>
                    <Input
                        label="Заголовок"
                        name={`content[broadcasts][${broadcastIndex}][title][${language}]`}
                        defaultValue={title[language]}
                    />

                    <TextArea
                        label="Описание"
                        name={`content[broadcasts][${broadcastIndex}][description][${language}]`}
                        defaultValue={description[language]}
                    />
                </>
            )}
        />
    );
}
